import React, { useEffect, useState } from "react";
import { Container, Button, Dropdown, DropdownButton, Form, Col, Row, Alert, Label, Modal, Spinner, InputGroup } from 'react-bootstrap';
import { GlobalContext } from "../../../services/GlobalProvider";
import ErrorManager from "../../../components/error-manager/ErrorManager";
import { FactureService } from '../../../services/FactureService';
import { EditionService } from '../../../services/EditionService';
import { formatTableHeadersFromPrefs, granted, getFile } from '../../../helper/Helper'
import SendMailDialog from "../../../components/send-mail-dialog/SendMailDialog";


const ModalValidation = (props) => {

    const { folderDetails, grants } = React.useContext(GlobalContext);
    const [globalError, setGlobalError] = useState()
    const [sendMailDialog, setSendMailDialog] = useState({})

    const [generatedIdDocument, setGeneratedIdDocument] = useState()
    const [generatedInfo, setGeneratedInfo] = useState()

    const [isDlFacturePDFLoading, setIsDlFacturePDFLoading] = useState(false)
    const [isDlProformaPDFLoading, setIsDlProformaPDFLoading] = useState(false)


    useEffect(() => {

        if (props.postValidateResponse?.data?.data && props.currentBrouillon?.type && Object.keys(props.postValidateResponse?.data?.data[props.currentBrouillon.type]).length > 0) {

            const responseIdDocument = Object.keys(props.postValidateResponse?.data?.data[props.currentBrouillon.type])[0]
            const responseStatus = props.postValidateResponse?.data?.data[props.currentBrouillon.type][responseIdDocument]?.status //no_change...
            const responseOperation = props.postValidateResponse?.data?.data[props.currentBrouillon.type][responseIdDocument]?.operation //create, update...

            let responseGeneratedDocumentString = props.postValidateResponse?.data?.data[props.currentBrouillon.type][responseIdDocument][props.currentBrouillon.type][0]

            if (responseStatus == "no_change") {
                setGeneratedInfo({ 'info': responseGeneratedDocumentString, 'status': 'no_change' })
            }
            if (responseOperation == "update" || responseOperation == "create") {
                setGeneratedIdDocument(responseGeneratedDocumentString)
            }
        }
    }, []);

    function sendEmail() {
        let documentType = ""
        if (props.currentBrouillon?.type == "facture" || props.currentBrouillon?.type == "avoir") {
            documentType = "factures"
        }
        if (props.currentBrouillon?.type == "proforma") {
            documentType = "proformas"
        }
        setSendMailDialog({
            "clientIdList": [props.currentBrouillon?.client_id],
            "folderId": folderDetails?.dossier?._id,
            "editionUrl": documentType,
            "params": {
                "filter": {
                    "_id": "=" + generatedIdDocument
                }
            },
            "totalElements": 1,
            "show": true
        })
    }

    function downloadFacturePDF() {
        setIsDlFacturePDFLoading(true)
        EditionService.getFacture(folderDetails?.dossier?._id, generatedIdDocument, "pdf").then(res => {
            setIsDlFacturePDFLoading(false)
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                getFile(res)
            }
        }).catch(error => {
            setIsDlFacturePDFLoading(false)
            setGlobalError(error)
        });
    }

    function downloadProformaPDF() {
        setIsDlProformaPDFLoading(true)
        EditionService.getProforma(folderDetails?.dossier?._id, generatedIdDocument, "pdf").then(res => {
            setIsDlProformaPDFLoading(false)
            if (!res.data) {
                setGlobalError({ statusText: res.statusText })
            } else {
                getFile(res)
            }
        }).catch(error => {
            setIsDlProformaPDFLoading(false)
            setGlobalError(error)
        });
    }

    return (
        <>

            <SendMailDialog clientIdList={sendMailDialog.clientIdList} folderId={sendMailDialog.folderId} editionUrl={sendMailDialog.editionUrl} params={sendMailDialog.params} totalElements={sendMailDialog.totalElements} show={sendMailDialog.show} setCloseModal={() => setSendMailDialog({ show: false })} />

            <Modal size="sm" show centered>

                <Modal.Header className="border-0 pb-0">
                    {props.currentBrouillon?.type == "facture" &&
                        <>La facture a bien été validée.</>
                    }
                    {props.currentBrouillon?.type == "proforma" &&
                        <>La proforma a bien été validée.</>
                    }
                    {props.currentBrouillon?.type == "avoir" &&
                        <>L'avoir a bien été validé.</>
                    }
                </Modal.Header>

                <Modal.Body className="">
                    <ErrorManager error={globalError} />
                    {generatedInfo &&
                        <Alert variant="info">
                            {generatedInfo.info}
                        </Alert>
                    }

                    {(generatedIdDocument && (generatedInfo?.status != 'no_change')) &&
                        <div className="">
                            {(granted(grants, "factures.consult") && props.currentBrouillon?.type == "facture") &&
                                <>
                                    <Button disabled={isDlFacturePDFLoading} className="w-100 mb-2" variant="primary" onClick={() => downloadFacturePDF()}>
                                        {isDlFacturePDFLoading &&
                                            <Spinner size="sm" animation="border" className="me-2" />
                                        }
                                        Imprimer la facture
                                    </Button>
                                    <Button className="w-100 mb-2" variant="secondary" onClick={() => sendEmail()}>Envoyer par mail</Button>
                                </>
                            }
                            {(granted(grants, "factures.consult") && props.currentBrouillon?.type == "avoir") &&
                                <>
                                    <Button disabled={isDlFacturePDFLoading} className="w-100 mb-2" variant="primary" onClick={() => downloadFacturePDF()}>
                                        {isDlFacturePDFLoading &&
                                            <Spinner size="sm" animation="border" className="me-2" />
                                        }
                                        Imprimer l'avoir
                                    </Button>
                                    <Button className="w-100 mb-2" variant="secondary" onClick={() => sendEmail()}>Envoyer par mail</Button>
                                </>
                            }
                            {(granted(grants, "proformas.consult") && props.currentBrouillon?.type == "proforma") &&
                                <>
                                    <Button disabled={isDlProformaPDFLoading} className="w-100 mb-2" variant="primary" onClick={() => downloadProformaPDF()}>
                                        {isDlProformaPDFLoading &&
                                            <Spinner size="sm" animation="border" className="me-2" />
                                        }
                                        Imprimer la proforma
                                    </Button>
                                    <Button className="w-100 mb-2" variant="secondary" onClick={() => sendEmail()}>Envoyer par mail</Button>
                                </>
                            }
                        </div>
                    }
                </Modal.Body>

                <Modal.Footer className="border-0">
                    <Button variant="secondary" onClick={() => props.setClose(generatedIdDocument)} >
                        Fermer
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    )
}
export default ModalValidation;
